import React, {useState, useEffect} from 'react'
import backIcon from '../../../../../_metronic/images/back_icon.svg'
import {useNavigate,useParams} from 'react-router-dom'
import {useLazyQuery, useMutation} from '@apollo/client'
import SearchListOld from '../../../../sharedComponent/SearchListOld'
import {GET_SCHEDULED_REPORTS, DELETE_SCHEDULE_REPORT} from '../../../../../utils/GraphQLAPI'
import {Dropdown} from 'react-bootstrap'
import {alert} from '../../../../../utils/helper'
import moment from 'moment'
const Toolbar = ({clickHandler}:{clickHandler:()=>void}) => {
  return (
    <button onClick={clickHandler} className='btn btn-danger fw-bold fs-base  fs-6 ms-4 px-5'>
      
      Delete Selected
    </button>
  )
}

const ScheduledReports = () => {
  const navigate = useNavigate()
  const getUrlParams = useParams()
  const [heading, setHeading] = useState('')
  const [urlRedirect, setUrlRedirect] = useState('')
  const [isCheckAll, setIsCheckAll] = useState<any>(false)
  const [selectedReports, setSelectedReports] = useState<Array<string>>([])
  const [filterOptions, setFilterOptions] = useState({
    page: 1,
    perPage: 10,
  })
  const [getScheduledReports, {loading, data: scheduledReports}] = useLazyQuery(
    GET_SCHEDULED_REPORTS,
    {
      variables: {
        scheduleReportListInput: filterOptions,
      },
      fetchPolicy: 'network-only',
    }
  )
  useEffect(() => {
    getScheduledReports()
  }, [filterOptions])
  const [deleteScheduleReport] = useMutation(DELETE_SCHEDULE_REPORT, {
    onCompleted: () => {
      alert('Scheduled Report deleted successfully', 'success')
      setSelectedReports([])
      getScheduledReports()
    },
  })
  useEffect(() => {
    if (getUrlParams.adminUser === 'systemadmin') {
      setHeading('TPV Reports')
      setUrlRedirect('tpv-report')
    } else if (getUrlParams.adminUser === 'qcuser') {
      setHeading('TPV Records List')
      setUrlRedirect('tpv-recording-list')
    }
  }, [getUrlParams])
  const handleBackNavigation = () => {
    navigate(`/${getUrlParams.adminUser}/${urlRedirect}`, {})
  }
  const handleClick = (e: any) => {
    const {id, checked} = e.target
    setSelectedReports([...selectedReports, id])
    if (!checked) {
      setSelectedReports(selectedReports.filter((item: any) => item !== id))
    }
  }
  // Checkbox
  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll)
    setSelectedReports(
      scheduledReports?.getAllReportSchedules?.scheduleReportList?.map(
        ({reportSettingsId}: any) => reportSettingsId
      )
    )
    if (isCheckAll) {
      setSelectedReports([])
    }
  }
  const handleDelete=()=>{
    deleteScheduleReport({
        variables: {
          reportSettingsIds: selectedReports,
        },
      })
  }
  return (
    <div className='cust-det-block'>
      <div
        className='d-flex flex-row justify-content-between'
        style={{height: '48px', marginBottom: '20px'}}
      >
        <div className='d-flex'>
          <div
            className='svg-icon svg-icon-3 svg-icon-muted me-4 mt-4 align-items-center'
            style={{cursor: 'pointer'}}
            onClick={() => handleBackNavigation()}
          >
            <img src={backIcon} alt='back' />
          </div>
          <div className='d-flex flex-column'>
            <span className='fs-3 fw-bold text-gray-900'>Scheduled Reports</span>
            <span className='text-gray-500 fw-semibold lh-20px fs-7'>
              {`Home - ${heading} - Scheduled Reports`}
            </span>
          </div>
        </div>
      </div>

      <SearchListOld
        isSearchable={false}
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        selectedCount={selectedReports.length}
        paginatedCount={scheduledReports?.getAllReportSchedules?.scheduleReportList.length}
        listCount={scheduledReports && scheduledReports?.getAllReportSchedules?.totalCount}
        listLoading={loading}
        toolbar={selectedReports && selectedReports.length > 0 && <Toolbar clickHandler={handleDelete} />}
      >
        <div className='table-responsive-xxl'>
          <table className='table table-row-dashed gy-7 gs-7'>
            <thead>
              <tr className='fw-bold fs-6 text-gray-700 border-bottom-2 border-gray-200'>
                <th className='w-25px'>
                  <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                    <input
                      className='datatable-cell-center datatable-cell datatable-cell-check form-check-input bg-light-primary'
                      type='checkbox'
                      name='selectAll'
                      id='selectAll'
                      onChange={(e) => handleSelectAll()}
                      checked={
                        selectedReports.length ===
                        scheduledReports?.getAllReportSchedules?.scheduleReportList.length
                      }
                    />
                  </label>
                </th>
                <th className='min-w-150px ps-0 header_title'>Recurring Type</th>
                <th className='min-w-150px ps-0 header_title'>Subject</th>
                <th className='min-w-150px ps-0 header_title'>Day/Date</th>
                <th className='min-w-150px ps-0 header_title'>Time</th>
                <th className='min-w-200px ps-0 header_title'>Receiver Email</th>
                <th className='min-w-200px ps-0 header_title'>Created Date/Time</th>
              </tr>
            </thead>
            <tbody>
              {scheduledReports &&
                scheduledReports?.getAllReportSchedules?.scheduleReportList?.map(
                  ({
                    reportSettingsId,
                    reportFrequency,
                    reportName,
                    reportTime,
                    calendarDay,
                    reportDay,
                    createdAt,
                    user
                  }: any) => {
                    return (
                      <tr key={reportSettingsId} className='border-bottom-2'>
                        <td >
                          <label className='form-check form-check-sm form-check-custom form-check-solid me-5 '>
                            <input
                              className='form-check-input bg-light-primary'
                              type='checkbox'
                              name={reportTime}
                              id={reportSettingsId}
                              onChange={(e) => handleClick(e)}
                              checked={selectedReports.includes(reportSettingsId)}
                            />
                          </label>
                        </td>
                        <td className='text-gray-500 ps-0  fs-6 fw-semibold'>{reportFrequency}</td>
                        <td className='text-gray-500 ps-0  fs-6 fw-semibold'>{reportName?reportName:'-'}</td>
                        <td className='text-gray-500 ps-0  fs-6 fw-semibold'>
                          {Boolean(calendarDay) && calendarDay}
                          {Boolean(reportDay) && reportDay}
                          {!Boolean(calendarDay) && !reportDay && '-'}
                        </td>
                        <td className='text-gray-500 ps-0  fs-6 fw-semibold'>{reportTime}</td>
                        <td className='text-gray-500 ps-0  fs-6 fw-semibold'>{user.emailId}</td>
                        <td className='text-gray-500 ps-0  fs-6 fw-semibold'>
                        {moment.utc(createdAt).tz("America/New_York").format("DD MMM YYYY, hh:mm A")}
                        </td>
                        <td className='content'>
                          <Dropdown className='show-override'>
                            <Dropdown.Toggle
                              id='dropdown-custom-1'
                              className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                              style={{background: 'none!important'}}
                            >
                              <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='py-2 menu-state-bg-primary'>
                              <Dropdown.Item
                                as='div'
                                className='text-gray-600 fs-7 menu-item p-0'
                                onClick={() => {
                                  deleteScheduleReport({
                                    variables: {
                                      reportSettingsIds: [reportSettingsId],
                                    },
                                  })
                                }}
                              >
                                <div className='menu-link text-danger text-hover-white'>Delete</div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    )
                  }
                )}
            </tbody>
          </table>
        </div>
      </SearchListOld>
    </div>
  )
}
export default ScheduledReports
